import React from "react";
import Typography from "@material-ui/core/Typography";
import { FieldArray } from "formik";
import { makeStyles } from "@material-ui/core";
import FormLabel from "@material-ui/core/FormLabel";
import IconButton from "@material-ui/core/IconButton";
import InputField from "../../common/InputField";
import Paper from "@material-ui/core/Paper";
import CloseIcon from "@material-ui/icons/Close";
import Details from "../../common/Details";
import FormSection from "../../common/FormSection";
import FormStep from "../../common/FormStep";
import PleaseExplain from "../../common/PleaseExplain";
import YesNoField from "../../common/YesNoField";

// TODO: consider extracting <PleaseExplain><TextareaField /></...> pattern
//  if only to mark such fields as required when shown

const useStyles = makeStyles((theme) => ({
  formControl: {
    display: "block",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  root: {
    marginBottom: theme.spacing(4),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    zIndex: 200,
  },
  paper: {
    position: "relative",
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),

    "& .MuiFormControl-root": {
      marginBottom: 0,
      marginTop: 0,
      "&:not(:last-child)": {
        marginBottom: theme.spacing(2),
      },
    },

    "& .MuiInputBase-root": {
      minWidth: 250,
    },
  },
}));

const InsuranceAndSafetyFields = () => {
  return (
    <FormStep>
      <FormSection title="K. Insurance Information">
        <Details>
          <p>
            As a prospective contractor, subcontractor, or consultant, you will
            be required to maintain an insurance program compliant with our
            Company standard Terms & Conditions. Your insurance broker(s) must
            complete an insurance Verification Form, and you must attach this
            completed form as part of your registration here.
          </p>
          <br />
          <p>
            Contract insurance terms and conditions may change, types of
            coverage may be added or deleted, limits of liability increased or
            reduced, and other requirements may be waived or extended, depending
            on the proposed Scope of Work, subcontract value, overall risk of
            subcontractor's work, if your work is part of our performance to our
            client, any applicable client flow-down provisions, regulations, and
            other business considerations.
          </p>
          <br />
          <p>
            Final insurance terms and conditions are reviewed and approved by
            Risk Management.
          </p>
        </Details>

        <YesNoField
          label="1. Do you agree to provide insurance as required by the Scope of Work and contract Terms and Conditions?"
          name="insuranceRequiredByScopeofWork"
          required
        />
      </FormSection>

      <FormSection title="L. Safety">
        <YesNoField
          label="1. Do you have a full-time safety professional on staff?"
          name="safetyPro"
          required
        />
        <PleaseExplain name="safetyPro">
          <p>Please provide name, title, phone and email address</p>
          <br />
          <InputField label="Name" name={`pName`} required />
          <InputField label="Title" name={`pTitle`} required />
          <InputField
            label="Phone number (###-###-####)"
            name={`pPhone`}
            type="tel"
            required
          />
          <InputField label="Email" name={`pEmail`} type="email" required />
        </PleaseExplain>
        <YesNoField
          label="2. Has your company received any OSHA citations within the prior three years?"
          name="OSHACitations"
          required
        />
        <PleaseExplain name="OSHACitations">
          <p>
            Please describe the nature of the citation type (Serious, Willful,
            Repeat, Other), the value of the fine, and the abatement agreed
            upon. Include the name of the person in your company who will
            address any questions about the citation we may have.
          </p>
          <br />
          <InputField
            label="Citation Type"
            name={`oshaCitationType`}
            required
          />
          <InputField label="Fine Amounts" name={`oshaFineAmounts`} required />
          <InputField label="Abatement" name={`oshaAbatement`} required />
          <InputField label="Contact" name={`oshaContact`} required />
        </PleaseExplain>
      </FormSection>
    </FormStep>
  );
};

export default InsuranceAndSafetyFields;
